import { PropsWithChildren } from 'react';
import { Dialog, DialogContent, IconButton, Grow } from '@evaneos/b2b-ui';

import CloseIcon from '@evaneos/b2b-ui/icons/Close';

type Props = {
    displayCloseButton: boolean;
    closePhoningModal: () => void;
    children: React.ReactNode;
    showCallWidget: boolean;
};

const PhoningModalComponent = ({
    displayCloseButton,
    closePhoningModal,
    children,
    showCallWidget,
}: PropsWithChildren<Props>) => {
    const handleClose = (): void => {
        closePhoningModal();
    };

    // When call is active, render children directly (ActiveCallWidget has its own wrapper)
    if (showCallWidget) {
        return children;
    }

    // Otherwise render in full Dialog
    return (
        <Dialog
            open={true}
            onClose={displayCloseButton ? undefined : handleClose}
            slots={{
                transition: Grow,
            }}
            slotProps={{
                transition: {
                    timeout: 250,
                },
                paper: {
                    sx: {
                        maxWidth: { xs: '100%', sm: 817 },
                        maxHeight: '90vh',
                        borderRadius: 2,
                        boxShadow: 16,
                    },
                },
            }}
            data-testid="phoning-modal"
            maxWidth="sm"
            fullWidth
        >
            {!displayCloseButton && (
                <IconButton
                    onClick={handleClose}
                    data-testid="phoning-modal-close"
                    sx={{
                        position: 'absolute',
                        top: 16,
                        right: 16,
                    }}
                >
                    <CloseIcon />
                </IconButton>
            )}
            <DialogContent
                sx={{
                    padding: { xs: 2, md: 3 },
                }}
                data-testid="phoning-full-size"
            >
                {children}
            </DialogContent>
        </Dialog>
    );
};

export default PhoningModalComponent;
